

<!-- <nz-input-group [nzSuffix]="suffixIconSearch" style="margin-bottom: 16px;">
  <input type="text" nz-input placeholder="{{'search.field'|translateTA}}" [(ngModel)]="searchText" />
</nz-input-group>
<ng-template #suffixIconSearch>
  <i nz-icon nzType="search"></i>
</ng-template> -->
<div class="log-container">
    <div *ngIf="showFasterFilter" class="quick-filter">
        <search-input-new [searchProperties]="searchInputCodeCompany" (onChangeData)="onChangeCodeCompany($event)" class="full-width"></search-input-new>
        <search-input-new [searchProperties]="searchInputCodeProduct" (onChangeData)="onChangeCodeProduct($event)" [variables]="variables" [changes]="changeCodeCompany" class="full-width"></search-input-new>

    </div>
    <nz-divider *ngIf="showFasterFilter" class="filter-divider"></nz-divider>
    <div class="result">
        <ag-grid-angular
            style="width: 100%; height: 100%"
            [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
            [rowModelType]="'infinite'"
            cacheBlockSize = 100;
            cacheOverflowSize = 2;
            maxConcurrentDatasourceRequests = 1;
            infiniteInitialRowCount = 500;
            maxBlocksInCache = 20;
            [columnDefs]="fields"
            (gridReady)="onGridReady($event)"
            [localeText]="ls.getCurrentGridLocale()"
            overlayNoRowsTemplate   ="{{'NODATAFOUND'|translateTA}}"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [loadingOverlayComponent]="loadingOverlayComponent"
            [loadingOverlayComponentParams]="loadingOverlayComponentParams"
            [enableCellTextSelection]="true"
            [suppressClipboardPaste]="true"
            [multiSortKey]="true"
            (columnResized)="onResize($event)"
            (gridReady)="onGridReady($event)"
            (columnPinned)="onPinned($event)"
            (columnMoved)="onReoder($event)">
        </ag-grid-angular>
        <nz-float-button nzType="primary" [nzIcon]="reload" (nzOnClick)="refreshData()" class="log-float-button" ></nz-float-button>
        <ng-template #reload>
            <nz-icon nzType="reload" ></nz-icon>
        </ng-template>
    </div>


    <nz-drawer #drawer nzTitle="{{'requestbody'|translateTA}}" [nzWidth]="800" [nzClosable]="true"  [nzVisible]="visibleDrawer"
        (nzOnClose)="closeDrawer()">
        <div *nzDrawerContent class="json-container">
            <json-viewer [json]="jsonFormated" [readOnly]="true" [startFold]="false" [height]="'calc( 100vh - 100px)'"></json-viewer>
        </div>
    </nz-drawer>
</div>